<profile-section class="intro-section">
  <ng-container slot="title" i18n>Langues parlées</ng-container>

  <ng-container slot="main">
    <ul class="languages-list">
      <li class="languages-list__item" *ngFor="let language of model || []; trackBy: trackById">
        <profile-language
          [model]="language"
          [loading]="loading && loadingItem.name === language.name"
          [excludes]="model"
        ></profile-language>
      </li>
    </ul>
  </ng-container>
</profile-section>
